var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTattoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12591_10870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.362874 10.3985C4.12767 11.4917 6.30605 14.1712 7.55703 17.7821C7.71489 18.2399 8.37392 18.2162 8.51204 17.7505C9.60518 13.9857 12.2847 11.8074 15.8956 10.5564C16.3534 10.3985 16.3297 9.73948 15.8641 9.60136C12.0993 8.50823 9.92088 5.82867 8.6699 2.21778C8.51204 1.76 7.85301 1.78368 7.71489 2.24935C6.62175 6.01415 3.94219 8.19252 0.331303 9.44351C-0.126471 9.60136 -0.102793 10.2604 0.362874 10.3985Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3821 3.1413C22.0759 2.59276 21.2156 1.60223 20.6513 0.311779C20.4737 -0.0907465 19.8975 -0.110478 19.7278 0.295994C19.1793 1.60223 18.1888 2.46253 16.8983 3.02685C16.4958 3.20444 16.4761 3.7806 16.8825 3.9503C18.1888 4.49884 19.0491 5.48936 19.6134 6.77981C19.791 7.18234 20.3672 7.20207 20.5368 6.7956C21.0854 5.48936 22.0759 4.62906 23.3664 4.06474C23.7689 3.88715 23.7886 3.31099 23.3821 3.1413Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6474 13.2202C20.4698 12.8177 19.8936 12.798 19.7239 13.2044C19.1754 14.5107 18.1849 15.371 16.8944 15.9353C16.4919 16.1129 16.4722 16.6891 16.8786 16.8587C18.1849 17.4073 19.0452 18.3978 19.6095 19.6883C19.7871 20.0908 20.3632 20.1105 20.5329 19.704C21.0815 18.3978 22.072 17.5375 23.3625 16.9732C23.765 16.7956 23.7847 16.2194 23.3782 16.0497C22.072 15.5012 21.2117 14.5107 20.6474 13.2202Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12591_10870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.678,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTattoo);
export default __webpack_public_path__ + "static/media/Tattoo.314287e11f6cf9b2fae66f4cf0f845f9.svg";
export { ForwardRef as ReactComponent };